import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Card, Table, Button } from 'react-bootstrap';
import styles from './sellerdiscountblock3.module.css';
import { getDiscountList } from "../../apis/discount";
import { useCookies } from "react-cookie";

const SellerDiscountBlock3 = () => {
  const [cookies] = useCookies(["access_token", "user_info"]);
  const [discountList, setDiscountList] = useState([]);
  const sellerId = cookies["user_info"].sellerId;
  const accessToken = cookies["access_token"];

  useEffect(() => {
    const fetchDiscountList = async () => {
      try {
        const response = await getDiscountList({ sellerId }, accessToken);
        setDiscountList(response.data); // Assuming the data is in response.data
      } catch (error) {
        console.error("Error fetching discount list:", error);
      }
    };

    fetchDiscountList();
  }, [sellerId, accessToken]);

  return (
    <Card className={`mb-3 ${styles.card}`}>
      <div className="d-flex justify-content-between align-items-center p-3">
        <h2>Giảm giá</h2>
        <div>
          <Button variant="outline-secondary" className="me-2">Xuất</Button>
          <Button variant="warning">Tạo chương trình</Button>
        </div>
      </div>
      <Card.Body>
        <div className="d-flex mb-3">
          <Button variant="light" className="me-2">Tất cả</Button>
          <Button variant="light" className="me-2">Đang hoạt động</Button>
          <Button variant="light" className="me-2">Đã lên lịch</Button>
          <Button variant="light" className="me-2">Đã hết hạn</Button>
          <Button variant="light">+</Button>
        </div>
        <Table bordered>
          <thead>
            <tr>
              <th>Tiêu đề</th>
              <th>Trạng thái</th>
              <th>Phương thức</th>
              <th>Loại</th>
              <th>Tổ hợp</th>
              <th>Đã sử dụng</th>
            </tr>
          </thead>
          <tbody>
            {discountList.map((discount, index) => (
              <tr key={index}>
                <td>
                  {discount.discountCode || 'Chưa nhập'} <br />
                  Giảm giá {discount.discountType === 'Phần trăm' ? `${discount.discountValue}%` : `${discount.discountValue}đ`} <br />
                  Mua tối thiểu {discount.purchaseRequirement === 'amount' ? `${discount.minPurchase}đ` : (discount.purchaseRequirement === 'quantity' ? `${discount.minPurchase} sản phẩm` : 'Không có yêu cầu tối thiểu')} <br />
                  {discount.limitTotalUses ? `Giới hạn ${discount.totalUses} lần sử dụng` : 'Không giới hạn số lần sử dụng'} <br />
                  {discount.usePerCustomer ? 'Mỗi khách hàng sử dụng một lần' : ''}
                </td>
                <td className={discount.status === "active" ? "text-success" : "text-muted"}>{discount.status}</td>
                <td>{discount.method || 'Chưa chọn'}</td>
                <td>{discount.type || 'Không rõ'}</td>
                <td>{discount.combinable ? 'Có' : 'Không có thiết lập để kết hợp'}</td>
                <td>{discount.usageCount || 0}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="text-center mt-3">
          <span>Tìm hiểu thêm về <a href="#" className="text-decoration-none text-primary">Chương trình giảm giá</a></span>
        </div>
      </Card.Body>
    </Card>
  );
};

export default SellerDiscountBlock3;
